import './App.scss';
import { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Auth, Dashboard, Discover, Property, Settings } from './views';
import { Loader, MobileNavbar, Sidebar } from './components';
import { useAuthContext, useWindowDimensions } from './hooks';

function App() {
  const { user, authIsReady } = useAuthContext();
  const location = useLocation();
  const [isOnAuth, setIsOnAuth] = useState(false);
  const { width } = useWindowDimensions();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (width <= 900) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [width]);

  useEffect(() => {
    if (location.pathname === '/auth') {
      setIsOnAuth(true);
    } else {
      setIsOnAuth(false);
    }
  }, [location.pathname]);

  let classes = [];

  if (authIsReady) classes.push('ready');
  if (location.pathname === '/auth') classes.push('out');
  if (isMobile) classes.push('mobile');

  return (
    <div className={`App ${classes.join(' ')}`}>
      {authIsReady ? (
        <>
          {!isOnAuth && (!isMobile ? <Sidebar /> : <MobileNavbar />)}

          <div className={`view ${classes.join(' ')}`}>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/discover" element={<Discover />} />
              <Route path="/discover/:id/*" element={<Property />} />
              <Route path="/settings" element={<Settings />} />
              <Route
                path="/auth"
                element={!user ? <Auth /> : <Navigate to="/" />}
              />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </div>
        </>
      ) : (
        <div className="loader-container">
          <Loader />
        </div>
      )}
    </div>
  );
}

export default App;
